import { gql } from "@apollo/client";

export const RESOLVE_ERROR_LOG = gql`
  mutation ResolveErrorLog($id: ID!, $resolved: Boolean) {
    resolveErrorLog(id: $id, resolved: $resolved) {
      errorLog {
        id
        resolved
        resolvedAt
      }
      errors
    }
  }
`;

export const DELETE_ERROR_LOGS = gql`
  mutation DeleteErrorLogs($scope: String) {
    deleteErrorLogs(scope: $scope) {
      deletedCount
      errors
    }
  }
`;

/**
 * The handoff: the crashes as markdown with their backtraces, ready to paste to
 * whoever — or whatever — is going to fix them.
 *
 * A mutation and not a query because pressing the button changes the queue: the
 * groups it covered are stamped `copiedAt`. It answers with those rows, so the
 * list behind the button updates without a refetch.
 *
 * With `id` it is one crash in full; without, the same filters the page shows.
 */
export const COPY_ERROR_REPORT = gql`
  mutation CopyErrorReport($id: ID, $limit: Int, $status: String, $search: String) {
    copyErrorReport(id: $id, limit: $limit, status: $status, search: $search) {
      report
      errorLogs {
        id
        copiedAt
      }
      errors
    }
  }
`;
